import { render } from "./TabList.vue?vue&type=template&id=1ec2d448&scoped=true&ts=true"
import script from "./TabList.vue?vue&type=script&lang=ts"
export * from "./TabList.vue?vue&type=script&lang=ts"

import "./TabList.vue?vue&type=style&index=0&id=1ec2d448&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec2d448"]])

export default __exports__